import type { FC } from 'react';
import { useEffect, useRef } from 'react';
const CanvasSubscription: FC = () => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    const originalWidth = 295;
    const originalHeight = 240;
    const shadowOffsetY = 4;
    const shadowBlur = 8;
    const extraBottom = shadowOffsetY + shadowBlur;
    canvas.width = originalWidth + 5;
    canvas.height = originalHeight + extraBottom;
    ctx.translate(0, 0);
    ctx.shadowColor = 'rgba(0, 0, 0, 0.10)';
    ctx.shadowBlur = shadowBlur;
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = shadowOffsetY;
    ctx.fillStyle = '#fff';
    ctx.beginPath();
    ctx.moveTo(294.5, 158.859);
    ctx.bezierCurveTo(294.5, 168.984, 281.596, 175.699, 271.614, 174.003);
    ctx.bezierCurveTo(268.668, 173.502, 265.62, 173.239, 262.5, 173.239);
    ctx.bezierCurveTo(237.095, 173.239, 216.5, 190.643, 216.5, 212.112);
    ctx.bezierCurveTo(216.5, 222.945, 209.049, 240, 198.217, 240);
    ctx.lineTo(12.5, 240);
    ctx.bezierCurveTo(5.87259, 240, 0.5, 234.627, 0.5, 228);
    ctx.lineTo(0.5, 12);
    ctx.bezierCurveTo(0.5, 5.37259, 5.87258, 0, 12.5, 0);
    ctx.lineTo(282.5, 0);
    ctx.bezierCurveTo(289.127, 0, 294.5, 5.37258, 294.5, 12);
    ctx.lineTo(294.5, 158.859);
    ctx.closePath();
    ctx.fill();
  }, []);
  return <canvas ref={canvasRef} width={300} height={250} style={{
    display: 'block',
    backgroundColor: 'transparent',
    margin: '0 auto',
    zIndex: '1',
    position: 'absolute'
  }} data-sentry-component="CanvasSubscription" data-sentry-source-file="CanvasSubscription.tsx" />;
};
export default CanvasSubscription;